import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau4 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-18050" data-mp="3kcwb7vhnfb48">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18051" data-mp="3fc8bmlfctlye"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18052" data-mp="3ae6u44xktup1">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18053" data-mp="36dmwl093cp2d">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18054" data-mp="36f7tuxmsim3x">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18055" data-mp="2womwfdiurnml">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18056" data-mp="2mpxc7e3hhr36">
          <div className="text-left" data-id="element-18057" data-mp="2ip3lye2kk074">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18058" data-mp="175xwpstbwf5k">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18059" data-mp="1pvw5kb4yaca9">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18060" data-mp="1uswceo9mjj2f">
        <div className="max-w-4xl mx-auto" data-id="element-18061" data-mp="1guxz7m71hsoi">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18062" data-mp="1kx2pqc26y96x">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-18063" data-mp="5era5hkfzl7v">
            The "Metabolic Panic" Response: Why GLP-1 Users Plateau (And How To
            Break Through)
          </h1>
          <p className="text-sm sm:text-base text-gray-500 italic mb-6" data-id="element-18064" data-mp="2c6fc7tnii5zk">
            (From a Metabolic Specialist Who Spent 18 Months Trying To Solve Her
            Own Plateau)
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-18065" data-mp="1xg85gb6vabep">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-18066" data-mp="1tdtm7pzad9mw">
              <img src="https://cdn.magicpatterns.com/uploads/njKHWtEUNXzL7WtDqVKiu5/pasted-image.jpg" alt="Dr. Patricia Reed" className="w-full h-full object-cover" data-id="element-18067" data-mp="1of08bwg37gm7" />
            </div>
            <div className="flex-1" data-id="element-18068" data-mp="1jhql8ng67h1j">
              <div className="flex items-center gap-2 mb-2" data-id="element-18069" data-mp="1ehm3yv7fuia9">
                <span className="text-base font-medium text-gray-900" data-id="element-18070" data-mp="1ej6zan1ku596">
                  Written by Dr. Patricia Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-18071" data-mp="38ulpf4yi26pg" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18072" data-mp="3hcdwyncm1tn5">
                Verified Metabolic Health Specialist, Cedar Sinai Medical Center
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-18073" data-mp="3lbcyrz31paad">
                <div className="flex items-center gap-1" data-id="element-18074" data-mp="3q4pmm6zwhd22">
                  <ClockIcon className="h-4 w-4" data-id="element-18075" data-mp="3v3sgqwecdyv9" />
                  <span data-id="element-18076" data-mp="3v2hb0r1c6h1i">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-18077" data-mp="2ydrwnaox46ka">
                  <EyeIcon className="h-4 w-4" data-id="element-18078" data-mp="2yfcq0wzhxjgk" />
                  <span data-id="element-18079" data-mp="32fmta1vwlvrq">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-18080" data-mp="37c3jr2qksm7z">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-18081" data-mp="3ccrjccsvebdt" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-18082" data-mp="mn7h467loi4t">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18083" data-mp="rod9u419g5ec">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18084" data-mp="1vlfkhdps6zk8">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-18085" data-mp="24kkkypkwl2z1"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-18086" data-mp="24jiwnjevmjzd">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance — it has hit a "stress
            threshold." Here's how to break through it, or prevent it from ever
            happening.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18087" data-mp="2oacsmo0a3fz9">
            <div className="mb-1 flex items-center" data-id="element-18088" data-mp="32942tzc0shi4">
              <span className="font-medium mr-2" data-id="element-18089" data-mp="2xa9l70psgyzl">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18090" data-mp="3gw2rxnnemzto">
              <span className="font-medium mr-2" data-id="element-18091" data-mp="3lucmpx57vyer">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau4;